import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MprcIconButton, MprcIconButtonProps } from 'components/MprcIconButton';
import { useMprcTheme } from "components/MprcThemeProvider";
import React from 'react';

////////////////////////////////////////////////////////////////////////////////

interface IProps extends MprcIconButtonProps {
    title?: string;
    onClick: () => void;
}

////////////////////////////////////////////////////////////////////////////////

export const MprcInfoIconButton: React.FC<IProps> = ({ title, onClick, ...rest }) => {

    const { theme } = useMprcTheme();
    return (
        <MprcIconButton size="small" color="muted" {...rest}>
            <FontAwesomeIcon
                color="inherit"
                icon={faCircleInfo}
                title={title ?? theme.MprcInfoIconButton.title}
                onClick={onClick}
            />
        </MprcIconButton>
    );
};
